import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory } from "common";
import { SalesforceUrlPipe } from "../../shared/pipes/salesforce-url.pipe";
import { ApplicationProfileComponentData } from "./application-profile.component";

@Injectable()
export class ApplicationProfileAdapter {
	constructor(
		private readonly salesforceUrlPipe: SalesforceUrlPipe,
	) { }

	adaptOtherInfoListData = (data: ApplicationProfileComponentData): HorizontalListData[] => {
		return [
			HorizontalListFactory.createKeyValueRouterLinkItem({
				title: 'Broker',
				displayedValue: data?.application?.brokerName,
				routerLink: `/broker/${data?.application?.brokerId}/profile`,
				isValueHidden: !data?.application?.brokerName || !data?.application?.brokerId
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'First agent',
				displayedValue: data?.application?.firstAgent,
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Assigned agent',
				displayedValue: data?.application?.assignedAgent,
			}),
			HorizontalListFactory.createKeyValueRouterLinkItem({
				title: 'Loan number',
				displayedValue: data?.application?.loanNumber,
				routerLink: `/account/${data?.application?.loanId}/profile`,
				isValueHidden: !data?.application?.loanNumber || !data?.application?.loanId
			}),
			HorizontalListFactory.createKeyValueExternalLinkItem({
				title: 'Salesforce ID',
				displayedValue: data?.application?.uniqueId,
				externalLink: this.salesforceUrlPipe.transform(data?.application?.uniqueId),
				isValueHidden: !data?.application?.uniqueId
			}),
		]
	}

	adaptRenewalsListData = (data: ApplicationProfileComponentData): HorizontalListData[] => {
		// Resolved as a pair, never two independent fallbacks — an authoritative id next to a derived
		// number would link a real loan number to a different loan.
		const useDerived = data?.application?.renewalForLoanId == null;
		const renewalForLoanId = useDerived ? data?.application?.derivedRenewalForLoanId : data?.application?.renewalForLoanId;
		const renewalForLoanNumber = useDerived ? data?.application?.derivedRenewalForLoanNumber : data?.application?.renewalForLoanNumber;

		return [
			HorizontalListFactory.createKeyValueRouterLinkItem({
				title: 'Renewal for loan',
				displayedValue: renewalForLoanNumber,
				routerLink: renewalForLoanId ? `/account/${renewalForLoanId}/profile` : undefined,
				isValueHidden: !renewalForLoanNumber,
				valueTooltipMessage: useDerived && renewalForLoanNumber ? 'Derived from RYNO renewal records; not set on the application' : undefined
			}),
			HorizontalListFactory.createKeyValueStringItem({
				title: 'Renewal ready',
				displayedValue: data?.application?.renewalReady ? 'Yes' : 'No',
			}),
		]
	}
}
